import { render, staticRenderFns } from "./PoaSection.vue?vue&type=template&id=08b84f6d&scoped=true&"
import script from "./PoaSection.vue?vue&type=script&lang=js&"
export * from "./PoaSection.vue?vue&type=script&lang=js&"
import style0 from "./PoaSection.vue?vue&type=style&index=0&id=08b84f6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b84f6d",
  null
  
)

export default component.exports